import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    years: {}
}

const studyYearsSlice = createSlice({
    name: "studyYears",
    initialState,
    reducers: {
        init(state, action) {
            state.years = action.payload.years;
        }
    }
})

export const studyYearsActions = studyYearsSlice.actions;
export default studyYearsSlice
